__turbopack_context__.v({
  "component": "ddlGzG_component",
  "hide-for-large": "ddlGzG_hide-for-large",
  "hide-for-large-only": "ddlGzG_hide-for-large-only",
  "hide-for-medium": "ddlGzG_hide-for-medium",
  "hide-for-medium-only": "ddlGzG_hide-for-medium-only",
  "hide-for-small-only": "ddlGzG_hide-for-small-only",
  "imageContainer": "ddlGzG_imageContainer",
  "li": "ddlGzG_li",
  "panel": "ddlGzG_panel",
  "row": "ddlGzG_row",
  "show-for-large": "ddlGzG_show-for-large",
  "show-for-large-only": "ddlGzG_show-for-large-only",
  "show-for-medium": "ddlGzG_show-for-medium",
  "show-for-medium-only": "ddlGzG_show-for-medium-only",
  "show-for-small-only": "ddlGzG_show-for-small-only",
  "subtitle": "ddlGzG_subtitle",
  "title": "ddlGzG_title",
  "u-color-black": "ddlGzG_u-color-black",
  "u-color-blue": "ddlGzG_u-color-blue",
  "u-color-midnight": "ddlGzG_u-color-midnight",
  "u-color-primary-dark": "ddlGzG_u-color-primary-dark",
  "u-color-red": "ddlGzG_u-color-red",
  "u-color-white": "ddlGzG_u-color-white",
  "u-theme-black": "ddlGzG_u-theme-black",
  "u-theme-blue": "ddlGzG_u-theme-blue",
  "u-theme-dark": "ddlGzG_u-theme-dark",
  "u-theme-light": "ddlGzG_u-theme-light",
  "u-theme-red": "ddlGzG_u-theme-red",
  "u-theme-white": "ddlGzG_u-theme-white",
  "ul": "ddlGzG_ul",
});
